<div class="lessons-tab">
  <ng-template #addLessonCard>
    @if (!showAddLessonButton && showAddLessonButtonCard) {
      <app-add-lesson-button-morphable (buttonClick)="onAddLessonButtonClick($event)"
      [type]="addCardButtonType"></app-add-lesson-button-morphable>
    }
  </ng-template>

  <!-- div class="page-layout simple " fxFlex--><!-- TODO remettre ce wrapper -->

  <app-banner-info class="lessons-tab__banner-info exclude-elem-to-order-directive"
    [rolesCanShowBanner]="rolesCanShowBannerInfo"
    [situation]="usageOfLessonsDisplay">
  </app-banner-info>

  @if (!getIsRootFilter() && fieldsToDisplay.length > 0) {
    <button
      class="lessons-tab__filter-button"
      (click)="displayFilters()">
      @if (!displayFilter) {
        <span>{{ 'generic.show_filters' | translate }}</span>
      } @else {
        <span>{{ 'generic.hide_filters' | translate }}</span>
      }
      <mat-icon svgIcon="tune-rounded"></mat-icon>
    </button>
  }

  @if (!showSpinner && fieldsToDisplay.length > 0 && (getIsRootFilter()===false || (getIsRootFilter() && !isAssignmentView()))) {
    <mat-toolbar class="lessons-tab__toolbar filters exclude-elem-to-order-directive"
      [style.display]="(displayFilter && !getIsRootFilter() || (getIsRootFilter() && selectedCollection === 2)) ? 'block' : 'none'"
      >
      @if (getIsRootFilter() === false || (getIsRootFilter() && selectedCollection === 2)) {
        <mat-toolbar-row
          class="lessons-tab__toolbar-row">
          @if (hasConfiguredSearchFilterBar) {
            <app-configured-filter-bar-host
              class="lessons-tab__search-filters"
              [componentType]="configuredSearchFilterBar"
              [initialSelection]="searchFilterInitialSelection"
              [resultCount]="countEntities"
              (selectionChange)="launchSearchFromFilterSelection($event)">
            </app-configured-filter-bar-host>
          } @else {
            <app-search-filters class="lessons-tab__search-filters"
              [fields]="fieldsToDisplay"
              [initialsValues]="urlFilters"
              [multiSelectFields]="lessonsConfigurationService.settings.multiSelectSearchFields"
              [customLists]="{methods:methods}"
              [countEntities]="countEntities"
              [customFieldName]="customFieldName"
              [orderFields]="true"
              [displayedFiltersIcons]="displayedFiltersIcons"
              [origin]="'lesson'"
              [resetList]="resetList"
              [filtersToClearOnFormChange]="filtersToClearOnSearchFormChange"
              (launchSearch)="launchSearch($event)">
            </app-search-filters>
          }
          <!--<app-filter-by-steps-editor (filterToApply)="launchSearch($event)"
          [countEntities]="countEntities"
        ></app-filter-by-steps-editor>-->
        <!--  <button (click)="openFilter()">FILTER</button>
        <app-filters-by-steps-player
          (filterToApply)="launchSearch($event)"
          [countEntities]="countEntities"
                  [steps]="[{field: 'concepts', endpoint: 'concepts', setFilter: null, includeFilter: null, nameIncludeFilter: null, filter: 'concepts', title: 'quel période?'},
                          {
                              field: 'grade',
                              endpoint: 'educational_level',
                              setFilter: null,
                              includeFilter: 'concepts',
                              nameIncludeFilter: 'levels',
                              filter: 'level',
                              title: 'quel niveau?'
                          },
                          {
                              field: 'chapters',
                              endpoint: 'chapters',
                              setFilter: ['grade', 'concepts'],
                              includeFilter: null,
                              nameIncludeFilter: null,
                              filter: 'chapters',
                              title: 'quel matiere?'
                          },
                          {
                              field: 'sequences', endpoint: 'lesson_granule_search',
                              setFilter: ['concepts', 'chapters', 'format:lesson'],
                              includeFilter: null,
                              nameIncludeFilter: null,
                              filter: 'format',
                              title: 'quel matiere?'
                          }]"
        ></app-filters-by-steps-player>-->
      </mat-toolbar-row>
    }
  </mat-toolbar>
}

@if (isLearner && (getIsRootFilter())) {
  <div
    class="lessons-tab__header">
    <h1 class="lessons-tab__header-title">{{ ('lesson.model_list_title_' + selectedOption + currentChapters()) | translate }}</h1>
    <p class="lessons-tab__header-description">{{ ('lesson.model_list_description_' + selectedOption + currentChapters()) | translate }}</p>
  </div>
}

@if (displayCreateLessonHelper && showAddLessonButton) {
  <div class="mat-body create-lesson-helper">
    {{ 'lessons.create_lesson_helper'|translate }}
  </div>
}

@if (displayCommunityLessonHelper) {
  <div class="mat-body create-lesson-helper">
    {{ 'lessons.community_lesson_helper'|translate }}
  </div>
}

@if (showLoader || showSpinner) {
  <div>
    <mat-spinner></mat-spinner>
  </div>
}

<div class="lessons-tab__cards cards content touch-scroll"
         [ngClass]="{
            'lessons-tab__cards--learner': isLearner,
            'lessons-tab__cards--junior': this.selectedCollection === 0,
            'lessons-tab__cards--college': this.selectedCollection === 1,
            'lessons-tab__cards--python': this.selectedCollection === 2,
         }"
  [ngStyle]="{'visibility':(showLoader || showSpinner)?'hidden':'visible'}"
  #scrollContainer>

  @if (addCardButtonPosition === 'first') {
    <ng-container *ngTemplateOutlet="addLessonCard"></ng-container>
  }

  @for (dataCard of dataCards; track dataCard) {
    <app-card class="lessons-tab__card"
      [dataCard]="dataCard">
    </app-card>
  }

  @if (addCardButtonPosition === 'last') {
    <ng-container *ngTemplateOutlet="addLessonCard"></ng-container>
  }


</div>

<mat-paginator [length]="countEntities" [pageIndex]="pageIndex" [pageSizeOptions]="pageRangeOptions"
  (page)="onPaginateChange($event, type)">
</mat-paginator>


@if (showAddLessonButton && !showAddLessonButtonCard) {
  <div class="addBtnBottomRight" fx-layout="row"
    fx-flex fx-layout-align="end">
    <button [title]="'generic.create_lesson_title' | translate"
      (click)="lessonsService.launchEditor('', 'new', 'lesson')" class="add-file-button">
      <mat-icon svgIcon="add"></mat-icon>
    </button>
  </div>
}
</div>
